const programCurrencyTypes = [
  {
    title: 'Euro (€)',
    id: 'PCT00',
    index: 1,
    color: '#00b0f0',
    colorFilterValues: {
      invert:'62',
      sepia:'69',
      saturate:'4114',
      hueRotate:'161',
      brightness:'98',
      contrast:'101',
    }
  },
  {
    title: 'Dolard USA ($)',
    id: 'PCT01',
    index: 2,
    color: '#00b0f0',
    colorFilterValues: {
      invert:'62',
      sepia:'69',
      saturate:'4114',
      hueRotate:'161',
      brightness:'98',
      contrast:'101',
    }  },
  {
    title: 'Libra esterlina (£)',
    id: 'PCT02',
    index: 3,
    color: '#00b0f0',
    colorFilterValues: {
      invert:'62',
      sepia:'69',
      saturate:'4114',
      hueRotate:'161',
      brightness:'98',
      contrast:'101',
    }  },
  {
    title: 'Yen japonés (¥)',
    id: 'PCT03',
    index: 4,
    color: '#00b0f0',
    colorFilterValues: {
      invert:'62',
      sepia:'69',
      saturate:'4114',
      hueRotate:'161',
      brightness:'98',
      contrast:'101',
    }  },
  {
    title: 'Yuan (¥)',
    id: 'PCT04',
    index: 5,
    color: '#00b0f0',
    colorFilterValues: {
      invert:'62',
      sepia:'69',
      saturate:'4114',
      hueRotate:'161',
      brightness:'98',
      contrast:'101',
    }  },
  {
    title: 'Franco suizo (Fr)',
    id: 'PCT05',
    index: 6,
    color: '#00b0f0',
    colorFilterValues: {
      invert:'62',
      sepia:'69',
      saturate:'4114',
      hueRotate:'161',
      brightness:'98',
      contrast:'101',
    }  },
  {
    title: 'Multidivisa nacional',
    id: 'PCT06',
    index: 11,
    color: '#00b0f0',
    colorFilterValues: {
      invert:'62',
      sepia:'69',
      saturate:'4114',
      hueRotate:'161',
      brightness:'98',
      contrast:'101',
    }  },
  {
    title: 'Bitcoin (BTC)',
    id: 'PCT07',
    index: 10,
    color: '#00b0f0',
    colorFilterValues: {
      invert:'62',
      sepia:'69',
      saturate:'4114',
      hueRotate:'161',
      brightness:'98',
      contrast:'101',
    }  },
  {
    title: 'Ether (ETH)',
    id: 'PCT08',
    index: 9,
    color: '#00b0f0',
    colorFilterValues: {
      invert:'62',
      sepia:'69',
      saturate:'4114',
      hueRotate:'161',
      brightness:'98',
      contrast:'101',
    }  },
  {
    title: 'Cualquier criptomoneda',
    id: 'PCT10',
    index: 13,
    color: '#00b0f0',
    colorFilterValues: {
      invert:'62',
      sepia:'69',
      saturate:'4114',
      hueRotate:'161',
      brightness:'98',
      contrast:'101',
    }  },
  {
    title: 'Cualquier divisa o moneda virtual',
    id: 'PCT11',
    index: 16,
    color: '#00b0f0',
    colorFilterValues: {
      invert:'62',
      sepia:'69',
      saturate:'4114',
      hueRotate:'161',
      brightness:'98',
      contrast:'101',
    }  },
  {
    title: 'Ripple',
    id: 'PCT12',
    index: 12,
    color: '#00b0f0',
    colorFilterValues: {
      invert:'62',
      sepia:'69',
      saturate:'4114',
      hueRotate:'161',
      brightness:'98',
      contrast:'101',
    }  },
  {
    title: 'Utility Tokens',
    id: 'PCT13',
    index: 14,
    color: '#00b0f0',
    colorFilterValues: {
      invert:'62',
      sepia:'69',
      saturate:'4114',
      hueRotate:'161',
      brightness:'98',
      contrast:'101',
    }  },
  {
    title: 'Security Tokens',
    id: 'PCT14',
    index: 15,
    color: '#00b0f0',
    colorFilterValues: {
      invert:'62',
      sepia:'69',
      saturate:'4114',
      hueRotate:'161',
      brightness:'98',
      contrast:'101',
    }  },
  {
    title: 'Rublo Rusia',
    id: 'PCT15',
    index: 7,
    color: '#00b0f0',
    colorFilterValues: {
      invert:'62',
      sepia:'69',
      saturate:'4114',
      hueRotate:'161',
      brightness:'98',
      contrast:'101',
    }  },
  {
    title: 'Rupia India',
    id: 'PCT16',
    index: 8,
    color: '#00b0f0',
    colorFilterValues: {
      invert:'62',
      sepia:'69',
      saturate:'4114',
      hueRotate:'161',
      brightness:'98',
      contrast:'101',
    }  }
]

export default programCurrencyTypes
